import { polyfill as smoothScrollPolyfill } from 'seamless-scroll-polyfill';

smoothScrollPolyfill();
